var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading)?_c('div',{staticClass:"is-loading"},[_c('img',{staticClass:"logo",attrs:{"src":require("@/assets/img/icn-logo-w.png"),"alt":""}}),_c('div',{staticClass:"text"},[_vm._v("Please wait")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }